import { mapActions } from 'vuex';
import { login as loginMessage } from '@/config/auth-messages.json';

export default () => ({
  methods: {
    ...mapActions({
      openNotification: 'openNotification',
      closeNotification: 'closeNotification',
      logError: 'logError',
    }),
    async reCaptcha() {
      this.errorType = null;
      if (!this.$refs.username.value || !this.$refs.password.value) {
        this.errorType = 'missing-credentials';
        return null;
      }

      this.loading = true;

      try {
        // (optional) Wait until recaptcha has been loaded.
        const validBehavior = await this.$recaptchaLoaded();

        // Execute reCAPTCHA with action "login".
        const token = await this.$recaptcha('login');
        this.loading = false;

        if (!validBehavior) {
          this.errorType = 'recaptcha-validation-error';
        }

        return {
          validBehavior,
          token,
        };
      } catch (error) {
        this.loading = false;
        this.logError({
          errorFrom: 'ReCaptchaMixin:methods:reCaptcha',
          details: {
            ...error,
            message: error && error.message,
          },
        });
        if (error.name === 'TypeError' || error === null) {
          this.openNotification({
            notificationType: 'error',
            title: 'Google reCpactha Config Error',
            message: loginMessage.error.reCapcthaConfigError,
          });
        }
      }

      return {
        validBehavior: true,
        token: null,
      };
    },
  },
});
